var _circle, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBadge2Icon = function SvgBadge2Icon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4484,
    cy: 30.4483,
    r: 24.5053,
    fill: "#302862",
    stroke: "#272054",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5741 20.2441H37.5787C37.6244 20.2441 37.6692 20.2575 37.7082 20.2826C37.7472 20.3077 37.7789 20.3436 37.7998 20.3864C37.8207 20.4292 37.8301 20.4773 37.8268 20.5254C37.8236 20.5734 37.8079 20.6196 37.7814 20.6589L32.6995 28.1996C32.673 28.2389 32.6573 28.2852 32.6541 28.3333C32.6508 28.3815 32.6603 28.4296 32.6813 28.4725C32.7023 28.5153 32.7342 28.5512 32.7733 28.5763C32.8124 28.6013 32.8573 28.6145 32.903 28.6144H37.7557C37.804 28.6145 37.8512 28.6295 37.8916 28.6574C37.9319 28.6853 37.9638 28.725 37.9831 28.7716C38.0025 28.8183 38.0086 28.8698 38.0007 28.9201C37.9928 28.9703 37.9712 29.017 37.9386 29.0546L24.5273 42.3735L29.7613 32.9345C29.7788 32.8942 29.7864 32.85 29.7834 32.8058C29.7803 32.7616 29.7667 32.719 29.7438 32.6818C29.7209 32.6447 29.6895 32.6142 29.6525 32.5933C29.6154 32.5724 29.574 32.5617 29.532 32.5623L25.3081 32.6211C25.2674 32.6217 25.2273 32.6118 25.1911 32.5923C25.155 32.5727 25.1239 32.5442 25.1006 32.5091C25.0773 32.474 25.0625 32.4334 25.0575 32.3909C25.0525 32.3484 25.0574 32.3052 25.0719 32.2652L29.3413 20.4134C29.3594 20.3637 29.3912 20.3209 29.4328 20.2907C29.4743 20.2605 29.5236 20.2442 29.5741 20.2441Z",
    fill: "#D16E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0605 29.6922H30.2087C30.1631 29.6922 30.1183 29.6789 30.0793 29.6537C30.0403 29.6286 30.0086 29.5927 29.9877 29.5499C29.9667 29.5071 29.9574 29.459 29.9606 29.4109C29.9639 29.3629 29.9796 29.3167 30.006 29.2774L35.0888 21.7367C35.1151 21.6974 35.1306 21.6512 35.1337 21.6032C35.1368 21.5552 35.1273 21.5073 35.1063 21.4645C35.0853 21.4218 35.0536 21.386 35.0146 21.361C34.9756 21.3361 34.9309 21.3228 34.8853 21.3228H26.8806C26.8302 21.3228 26.781 21.3388 26.7394 21.3689C26.6979 21.399 26.6659 21.4417 26.6479 21.4913L22.3767 33.343C22.3625 33.3831 22.3577 33.4262 22.3628 33.4686C22.3679 33.511 22.3827 33.5515 22.406 33.5865C22.4292 33.6216 22.4602 33.6501 22.4963 33.6697C22.5323 33.6893 22.5723 33.6993 22.6129 33.699L26.8368 33.6401C26.8789 33.6393 26.9205 33.6499 26.9577 33.6707C26.9948 33.6915 27.0264 33.722 27.0493 33.7592C27.0722 33.7964 27.0858 33.8392 27.0887 33.8835C27.0917 33.9278 27.0839 33.9721 27.0661 34.0123L23.6607 41.7614C23.403 42.3374 24.1193 42.84 24.5273 42.3736L35.2426 30.1324C35.2756 30.0951 35.2975 30.0484 35.3056 29.9981C35.3138 29.9478 35.3078 29.8961 35.2885 29.8493C35.2691 29.8026 35.2372 29.7628 35.1967 29.7349C35.1562 29.7069 35.1089 29.6921 35.0605 29.6922Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.1843 40.4807L26.4496 35.4152L24.354 40.1836L24.6357 42.2495L26.1843 40.4807Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.1343 31.24L23.4684 33.6872L25.8766 33.6536L24.1641 28.3826L23.1343 31.24Z",
    fill: "url(#paint2_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.6334 29.6922H30.2089C30.1632 29.6922 30.1184 29.6789 30.0794 29.6537C30.0404 29.6286 30.0087 29.5927 29.9878 29.5499C29.9669 29.5071 29.9575 29.459 29.9607 29.4109C29.964 29.3629 29.9797 29.3167 30.0062 29.2774L30.3334 28.792L28.6234 21.3228H26.8807C26.7828 21.3228 29.8061 36.3454 29.8061 36.3454L30.6203 35.4152L32.6334 29.6922Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7861 21.3418L29.4967 20.255L37.6027 20.2423C37.648 20.2447 37.6916 20.2611 37.7281 20.2895C37.7646 20.3178 37.7924 20.3568 37.808 20.4017L35.1146 21.4885L26.7861 21.3418Z",
    fill: "#FCE13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7861 21.3418L29.4967 20.255L37.6027 20.2423C37.648 20.2447 37.6916 20.2611 37.7281 20.2895C37.7646 20.3178 37.7924 20.3568 37.808 20.4017L35.1146 21.4885L26.7861 21.3418Z",
    fill: "#FCE13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0757 29.6532L32.7725 28.5764C32.829 28.6057 32.8918 28.6188 32.9546 28.6144H37.7729C37.8097 28.6159 37.8456 28.6267 37.8777 28.6457C37.9098 28.6648 37.9372 28.6916 37.9575 28.724L35.1765 29.7202C35.1413 29.7016 35.1025 29.6916 35.0631 29.6912H30.1968C30.1539 29.6905 30.112 29.6773 30.0757 29.6532Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0605 29.6922C34.656 29.7347 34.2514 29.7574 33.8469 29.7728C33.4424 29.7882 33.0379 29.7936 32.6333 29.7954C32.2288 29.7972 31.8243 29.7891 31.4206 29.7728C31.0169 29.7565 30.6116 29.7347 30.207 29.6922C30.6116 29.6487 31.0161 29.6261 31.4206 29.6107C31.8251 29.5953 32.2288 29.5898 32.6333 29.588C33.0379 29.5862 33.4424 29.5944 33.8469 29.6116C34.2514 29.6288 34.656 29.6487 35.0605 29.6922Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7886 29.425C23.567 30.1495 23.334 30.8723 23.0895 31.5932C22.9693 31.9555 22.8421 32.3114 22.7193 32.67L22.5295 33.2062L22.4814 33.3403L22.4694 33.3738C22.4667 33.3815 22.4644 33.3893 22.4625 33.3973C22.4608 33.4114 22.4608 33.4257 22.4625 33.4399C22.4634 33.4691 22.4719 33.4974 22.4871 33.5218C22.5022 33.5463 22.5234 33.5659 22.5484 33.5784C22.5602 33.5851 22.573 33.5897 22.5862 33.592C22.593 33.5929 22.6 33.5929 22.6068 33.592H22.7709H23.0423L23.5851 33.5875C23.9467 33.5875 24.3082 33.5875 24.6707 33.5875C25.3939 33.5911 26.1176 33.608 26.8419 33.6382C26.1187 33.6889 25.3956 33.7261 24.6724 33.7496C24.3108 33.7641 23.9492 33.7714 23.5876 33.7813L23.0448 33.7922L22.7734 33.7976H22.6377C22.6243 33.7985 22.6108 33.7985 22.5974 33.7976C22.5818 33.7976 22.5662 33.7958 22.551 33.7922C22.521 33.7861 22.4921 33.7755 22.4651 33.7605C22.4085 33.7307 22.3607 33.6852 22.3268 33.6288C22.2929 33.5725 22.2742 33.5075 22.2727 33.4408C22.2725 33.4075 22.2763 33.3744 22.2839 33.3421C22.2839 33.3276 22.2942 33.3076 22.2976 33.2977L22.3105 33.2642L22.3586 33.1301L22.5544 32.5967C22.6884 32.2417 22.8181 31.8857 22.9555 31.5325C23.2183 30.8267 23.496 30.1242 23.7886 29.425Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8913 21.4876C34.2231 21.5148 33.5549 21.5284 32.8867 21.5284C32.2185 21.5284 31.5512 21.522 30.883 21.5112C30.2148 21.5003 29.5483 21.4777 28.8809 21.4478C28.2136 21.4179 27.5462 21.3807 26.8789 21.3273C27.5471 21.3001 28.2153 21.2866 28.8835 21.2866C29.5517 21.2866 30.2191 21.292 30.8873 21.3038C31.5555 21.3155 32.2219 21.3373 32.8893 21.3672C33.5566 21.3971 34.224 21.4297 34.8913 21.4876Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.4662 22.6569L35.0871 21.7367C35.1141 21.7025 35.131 21.6607 35.1359 21.6165C35.1408 21.5723 35.1334 21.5275 35.1146 21.4877L26.8789 21.3228C26.8285 21.3228 26.7793 21.3388 26.7377 21.3689C26.6962 21.399 26.6642 21.4417 26.6462 21.4913L24.2671 28.0991C26.0948 25.0959 30.1658 22.4622 34.4662 22.6569Z",
    fill: "#FCFFAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.0662 34.0123L23.6608 41.7613C23.4031 42.3373 24.1194 42.8399 24.5274 42.3735L25.4335 41.3383C24.7756 40.8185 25.3192 38.8812 27.0662 34.0123Z",
    fill: "#FCFFAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.8752 20.9062C29.4152 20.533 31.9033 20.2803 37.6243 20.2477H37.6028L29.4968 20.2604L27.8752 20.9062Z",
    fill: "#FCFFAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.0197 25.9597C28.0197 26.6269 27.8332 27.2792 27.4839 27.834C27.1346 28.3888 26.6381 28.8212 26.0571 29.0766C25.4762 29.3319 24.837 29.3988 24.2203 29.2686C23.6036 29.1384 23.0371 28.8171 22.5925 28.3453C22.1479 27.8734 21.8451 27.2723 21.7225 26.6179C21.5998 25.9634 21.6628 25.2851 21.9034 24.6686C22.144 24.0521 22.5515 23.5252 23.0743 23.1545C23.5971 22.7838 24.2118 22.5859 24.8405 22.5859C25.6837 22.5859 26.4923 22.9414 27.0885 23.5741C27.6848 24.2068 28.0197 25.0649 28.0197 25.9597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4239 26.2235C27.6293 24.8657 26.7586 23.5882 25.479 23.3703C24.1995 23.1523 22.9958 24.0763 22.7904 25.4341C22.585 26.792 23.4557 28.0694 24.7352 28.2874C26.0147 28.5053 27.2185 27.5813 27.4239 26.2235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.1069 24.1205C25.0062 24.8776 25.1069 25.8293 23.8347 25.9443C24.2114 26.1303 24.6323 26.2935 24.8951 26.6676C25.129 27.0008 25.3187 27.5623 25.3588 27.9694C25.4277 27.5301 25.3339 27.1179 25.5906 26.6691C25.6833 26.5026 25.8107 26.3606 25.9628 26.2541C26.115 26.1475 26.2881 26.0791 26.4688 26.0541C26.0625 25.8154 25.7099 25.8528 25.4616 25.3366C25.3651 25.1419 25.285 24.9385 25.2222 24.7289C25.1614 24.5166 25.1828 24.1886 25.0524 24.0341L25.1069 24.1205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 23.0818,
    y1: 25.2182,
    x2: 32.409,
    y2: 34.0632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FDC822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAA12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 24.3763,
    y1: 37.6015,
    x2: 26.8336,
    y2: 39.9318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFFF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFFC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FEF47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FDE65E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FCD436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCF2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 134.091,
    y1: 1041.19,
    x2: 303.186,
    y2: 1128.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFFF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFFC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FEF47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FDE65E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FCD436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCF2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 26.8773,
    y1: 28.8336,
    x2: 32.6334,
    y2: 28.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFF257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCF2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 30.0757,
    y1: 29.1487,
    x2: 37.9575,
    y2: 29.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDC822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE13C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6358,
    height: 29.9573,
    fill: "white",
    transform: "translate(19.2573 12.6002)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadge2Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/badge-2-icon.8a113c23.svg";
export { ForwardRef as ReactComponent };